import { render, staticRenderFns } from "./ParcoursExtraInformations.vue?vue&type=template&id=3dffcc8b&"
import script from "./ParcoursExtraInformations.vue?vue&type=script&lang=js&"
export * from "./ParcoursExtraInformations.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursExtraInformations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports